module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui active blurring inverted  dimmer"
  }, [_c('div', {
    staticClass: "ui loader"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f0869d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingApp.vue
// module id = 349
// module chunks = 1